module.exports = __webpack_public_path__ + "img/3e06c3f.jpg";